import React, { ReactNode, useState, useEffect } from "react"
import { LDProvider, LDContext } from "launchdarkly-react-client-sdk"
import { useAuth0 } from "@auth0/auth0-react"
import { EnvironmentService } from "../services/EnvironmentService"

const LaunchDarklyProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [context, setContext] = useState<LDContext>()

  const { user } = useAuth0()

  useEffect(() => {
    if (user) {
      setContext({
        kind: "user",
        id: user.sub,
        key: user.sub,
      })
    }
  }, [user])

  if (context) {
    return (
      <LDProvider
        clientSideID={EnvironmentService.getLaunchDarklyClientId()}
        deferInitialization={true}
        context={context}
      >
        {children}
      </LDProvider>
    )
  }

  return <>{children}</>
}

export default LaunchDarklyProvider
